var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowIconSrccomponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#7451EB",
  fillRule: "evenodd",
  d: "M12.957 18.573a.75.75 0 0 1-.444.957 7.73 7.73 0 0 1-4.925.129 7.86 7.86 0 0 1-4.033-2.882A8.1 8.1 0 0 1 2 12.018a8.1 8.1 0 0 1 1.534-4.766 7.86 7.86 0 0 1 4.02-2.9 7.73 7.73 0 0 1 4.925.106.75.75 0 0 1 .448.954.73.73 0 0 1-.938.456 6.3 6.3 0 0 0-4.004-.085A6.4 6.4 0 0 0 4.717 8.14a6.6 6.6 0 0 0-1.247 3.875 6.6 6.6 0 0 0 1.264 3.869 6.4 6.4 0 0 0 3.279 2.342 6.3 6.3 0 0 0 4.004-.104.73.73 0 0 1 .94.451",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#7451EB",
  fillRule: "evenodd",
  d: "M22 12c0 .212-.08.414-.22.551l-4.364 4.278c-.262.258-.656.22-.878-.085-.223-.304-.19-.76.073-1.018l3.064-3.004-11.052.001c-.344 0-.623-.323-.623-.722s.279-.722.623-.722l11.052-.001-3.064-3.004c-.263-.258-.296-.714-.073-1.018s.616-.343.878-.085l4.363 4.278c.14.137.221.339.221.551",
  clipRule: "evenodd"
})));
export default SvgArrowIconSrccomponent;